import { Card, CardBody, Col, Input } from "reactstrap";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const BlogSearch = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title="Search" headClass="pb-0 border-0" />
        <CardBody>
          <div className="blog-search">
            <Input type="text" placeholder="Search here..." />
            <i className="fa fa-search" />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BlogSearch;
